import { render, staticRenderFns } from "./viewLeaveCanaelReason.vue?vue&type=template&id=634ff5cc&"
import script from "./viewLeaveCanaelReason.vue?vue&type=script&lang=js&"
export * from "./viewLeaveCanaelReason.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCol,VContainer,VForm,VRow,VSheet,VTextarea})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('634ff5cc')) {
      api.createRecord('634ff5cc', component.options)
    } else {
      api.reload('634ff5cc', component.options)
    }
    module.hot.accept("./viewLeaveCanaelReason.vue?vue&type=template&id=634ff5cc&", function () {
      api.rerender('634ff5cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Page/EssAdmin/Leave/LeaveCanaelReason/viewLeaveCanaelReason.vue"
export default component.exports